// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "tr td[data-v-ada730a4] {\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n}\ntr.editing td[data-v-ada730a4] {\n  vertical-align: top;\n}\ntr.editing td .product-field[data-v-ada730a4] {\n  min-width: 170px;\n}\ntr.editing-actions[data-v-ada730a4] {\n  border-top: 0;\n}\n", ""]);
// Exports
module.exports = exports;
